import { useEffect } from 'react'
import { useIntersectionObserver } from 'usehooks-ts'

export function useLoadMore({
  enabled,
  isLoading,
  isValidating,
  setSize,
  size,
}: {
  enabled: boolean
  isLoading: boolean
  isValidating: boolean
  setSize: (size: number) => void
  size: number
}) {
  const { isIntersecting, ref } = useIntersectionObserver({ threshold: 0.1 })

  useEffect(() => {
    if (isIntersecting && enabled && !isLoading && !isValidating) {
      setSize(size + 1)
    }
  }, [isIntersecting, enabled, isLoading, isValidating, setSize, size])

  return ref
}
